export default __webpack_public_path__ + "3c053a6bbf9398c1f506716700c2f0ca.png";